import { render, staticRenderFns } from "./ednBtn.vue?vue&type=template&id=21df385c&"
import script from "./ednBtn.vue?vue&type=script&lang=js&"
export * from "./ednBtn.vue?vue&type=script&lang=js&"
import style0 from "./ednBtn.vue?vue&type=style&index=0&id=21df385c&prod&lang=scss&"


/* normalize component */
import normalizer from "!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports